// Tryb — the studio's standard surfaces.

export function Card({ children, style, padding = 24 }) {
  return (
    <div
      style={{
        background: "var(--surface-card)",
        border: "1px solid var(--border-subtle)",
        borderRadius: "var(--radius-xl)",
        boxShadow: "var(--shadow-sm)",
        padding,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

/** The dark ink panel used for the things tryb wants to say in its own voice. */
export function InkCard({ children, style, padding = 24 }) {
  return (
    <div style={{ background: "var(--ink-900)", color: "var(--sand-75)", borderRadius: "var(--radius-xl)", padding, ...style }}>
      {children}
    </div>
  );
}

export function Overline({ children, color = "var(--text-muted)", style }) {
  return (
    <div
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: 11,
        letterSpacing: "var(--tracking-wider)",
        textTransform: "uppercase",
        color,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function SectionTitle({ children, size = "var(--text-lg)", style }) {
  return (
    <h2
      style={{
        margin: 0,
        fontFamily: "var(--font-display)",
        fontSize: size,
        fontWeight: 800,
        letterSpacing: "var(--tracking-snug)",
        ...style,
      }}
    >
      {children}
    </h2>
  );
}

export function Meter({ pct, color = "var(--ember-500)", track = "var(--sand-300)", style }) {
  return (
    <div style={{ height: 6, borderRadius: 999, background: track, overflow: "hidden", ...style }}>
      <div style={{ height: "100%", background: color, width: `${pct}%`, transition: "width var(--dur-slow) var(--ease-out)" }} />
    </div>
  );
}

export function EmptyState({ children, dashed = true, style }) {
  return (
    <div
      style={{
        padding: 28,
        border: dashed ? "1px dashed var(--border-strong)" : "1px solid var(--border-subtle)",
        borderRadius: "var(--radius-lg)",
        textAlign: "center",
        color: "var(--text-muted)",
        fontSize: "var(--text-sm)",
        lineHeight: 1.5,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
